import React, { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { postUser, getUser } from "../actions/user.actions";
import HorizontalForm from "./components/UserForm";
import PageHeader from "../../../shared/components/PageHeader";
import UserEditForm from "./components/UserEditForm";
const UserForm = ({ dispatch, currentUser, user, match }) => {
    const createFormData = (user) => {
        let userData;
        const hasUser = match.params.id && user && user.response && user.response.data && user.response.data.length;
        const userObj = hasUser ? user.response.data[0] : null;
        if (userObj) {
            userData = {
                first_name: userObj.firstName,
                last_name: userObj.lastName,
                email: userObj.email,
                phone_number: userObj.mobileNo,
            };
        }

        return userData;
    };

    function fetchUser() {
        dispatch(getUser({ searchWord: match.params.id, pageNum: 1, pageSize: 10 }));
    }

    const addUser = (values) => {
        dispatch(postUser(values, currentUser, match.params.id, user.response));
    };

    const reFectUserDetails = () => {
        if (match.params.id) {
            dispatch(getUser({ searchWord: match.params.id, pageNum: 1, pageSize: 10 }));
        }
    };

    useEffect(() => {
        if (match.params.id) {
            dispatch(getUser({ searchWord: match.params.id, pageNum: 1, pageSize: 10 }));
        }
    }, [dispatch, match.params.id]);

    return (
        <Container>
            <PageHeader header={`${match.params.id ? "Edit" : "Add"} User`} subheader={`${match.params.id ? "Edit user" : "Create new user"}`} />
            <Row>
                {match.params.id ? (
                    <UserEditForm userId={match.params.id} user={user} initialValues={createFormData(user)} fetchData={fetchUser} onSubmit={addUser} fetchUser={reFectUserDetails} />
                ) : (
                    <HorizontalForm userId={match.params.id} user={user} initialValues={createFormData(user)} fetchData={fetchUser} onSubmit={addUser} />
                )}
            </Row>
        </Container>
    );
};

export default connect((state) => ({
    currentUser: state.currentUser,
    user: state.viewuser,
}))(UserForm);
